import { Divider, Stack, DialogContent, DialogActions, Dialog, Button } from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { get } from 'lodash';
import { LoadingButton } from '@mui/lab';
import { useDispatch } from 'react-redux';

import { Strings } from '@app/constants';
import { FormProvider, RHFTextField } from '@app/components';
import { Header } from '@app/sections/header';
import { ILeaveManagement } from '../type';
import { addLeaveManagementSchema } from './validators';
import { addLeaveManagement, updateLeaveManagement } from '../slice';
import { useRequestState } from '@app/hooks';
import { selectAddLeaveManagementState, selectUpdateLeaveManagementState } from '../selectors';

interface Props {
  open: boolean;
  onClose: VoidFunction;
  row?: ILeaveManagement;
}

const AddLeaveDays = ({ open, onClose, row }: Props) => {
  const dispatch = useDispatch();
  const methods = useForm<ILeaveManagement>({
    resolver: yupResolver(addLeaveManagementSchema) as any,
    defaultValues: {
      leaveType: get(row, 'leaveType', ''),
      allowedDays: get(row, 'allowedDays', ''),
    },
  });

  const onSubmit = (form: ILeaveManagement) => {
    console.log('form', form);
    row
      ? dispatch(updateLeaveManagement({ ...form, id: row?.id }))
      : dispatch(addLeaveManagement({ ...form }));
  };
  const { loading: saveLeaveManagement } = useRequestState({
    stateSelector: row ? selectUpdateLeaveManagementState : selectAddLeaveManagementState,
    onSuccess: onClose,
    successMessageShown: true,
    errorShown: true,
  });

  return (
    <>
      <FormProvider methods={methods}>
        <Dialog open={open} fullWidth>
          <Header variant="dialog" title={Strings.button.addLeaveDays} onClose={onClose} />
          <Divider />
          <DialogContent>
            <Stack spacing={2} my={2}>
              <RHFTextField
                name="leaveType"
                required
                label={Strings.field.name}
                fullWidth
                variant="outlined"
                multiline
              />
              <RHFTextField
                name="allowedDays"
                required
                label={Strings.field.days}
                fullWidth
                variant="outlined"
                multiline
              />
            </Stack>
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button variant="outlined" color="inherit" onClick={onClose}>
              {Strings.button.cancel}
            </Button>
            <LoadingButton
              variant="contained"
              type="submit"
              onClick={methods.handleSubmit(onSubmit)}
              loading={saveLeaveManagement}
            >
              {Strings.button.save}
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export { AddLeaveDays };
